export enum ISplitDirection {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}
export interface ISplitObj {
  id1: string
  id2: string
  data: any
}

import Split from 'split.js'

const splitObjArr: ISplitObj[] = []

/**
 * destroy split object
 * @param splitObj split object
 * @param cleanArr clean array
 * @returns null
 */
const destroySplit = async (splitObj: ISplitObj, cleanArr: boolean = false) => {
  try {
    if (splitObj.data) {
      try {
        const mouseUpEvent = new MouseEvent('mouseup')
        window.dispatchEvent(mouseUpEvent)
        const mouseUpEventMobile = new MouseEvent('touchend')
        window.dispatchEvent(mouseUpEventMobile)
        splitObj.data.destroy()
        await new Promise((resolve) => setTimeout(resolve, 100))
        splitObj.data = null
      } catch (e) {
        ;() => {}
      }
    }
    if (cleanArr) {
      const splitObjArrIndex = splitObjArr.findIndex(
        (item) => item.id1 === splitObj.id1 && item.id2 === splitObj.id2
      )
      if (splitObjArrIndex > -1) {
        splitObjArr.splice(splitObjArrIndex, 1)
      }
    }
  } catch (error) {
    ;() => {}
  }
}
/**
 * eject split obj array
 * @returns null
 */
const ejectSplitObjArr = async () => {
  await splitObjArr.forEach(async (item) => {
    await destroySplit(item, true)
  })
  // clear array
  splitObjArr.splice(0, splitObjArr.length)
}

/**
 * init split js and make sure both elements are loaded
 * @param id1 element id 1
 * @param id2 element id 2
 * @param size1 size in percentage
 * @param size2 size in percentage
 * @param direction direction
 * @param screenSize breakpoint
 * @param onCollapsable on collapsable callback
 * @param onResize on resize function
 * @param count retry count
 * @returns split js instance or null
 */
const initSplit = async (
  id1: string,
  id2: string,
  size1: number,
  size2: number,
  direction: ISplitDirection = ISplitDirection.HORIZONTAL,
  screenSize: number = 1024,
  onCollapsable: Function | null = null,
  onResize: Function | null = null,
  count: number = 0
): Promise<any | null> => {
  const element1 = document.getElementById(id1)
  const element2 = document.getElementById(id2)
  if (count > 30) {
    return null
  } else {
    if (!element1 || !element2) {
      return await initSplit(
        id1,
        id2,
        size1,
        size2,
        direction,
        screenSize,
        onCollapsable,
        onResize,
        count + 1
      )
    } else {
      /**
       * post init split
       * @param splitObj split object
       * @returns null
       */
      const postInitSplit = async (splitObj: ISplitObj) => {
        if (window.innerWidth >= screenSize) {
          if (!splitObj?.data) {
            const data: any = {
              direction: direction,
              gutterSize: 4,
              sizes: [size1, size2],
              cursor: 'col-resize'
            }
            if (onCollapsable) {
              data.minSize = 0
              data.expandToMin = true
            }

            if (onResize || onCollapsable) {
              /**
               * on drag event
               */
              data.onDrag = async () => {
                const size1 =
                  direction == ISplitDirection.VERTICAL
                    ? element1.getBoundingClientRect().height
                    : element1.getBoundingClientRect().width
                const size2 =
                  direction == ISplitDirection.VERTICAL
                    ? element2.getBoundingClientRect().height
                    : element2.getBoundingClientRect().width

                if (onResize) {
                  onResize([size1, size2])
                }
                if (onCollapsable) {
                  const collapse = await onCollapsable([size1, size2])
                  if (collapse) {
                    if (size1 < size2) {
                      if (splitObj.data) {
                        splitObj.data.setSizes([0, 100])
                      }
                    } else {
                      if (splitObj.data) {
                        splitObj.data.setSizes([100, 0])
                      }
                    }
                    data.collapse = true
                  }
                }
              }
            }

            splitObj.data = Split([`#${id1}`, `#${id2}`], data) as any
          }
        } else {
          try {
            if (splitObj.data) {
              splitObj.data.destroy()
              await new Promise((resolve) => setTimeout(resolve, 100))
              splitObj.data = null
            }
          } catch (e) {
            return null
          }
        }
      }
      const splitObjArrIndex = splitObjArr.findIndex((item) => item.id1 === id1 && item.id2 === id2)
      if (splitObjArrIndex > -1) {
        const splitObj = splitObjArr[splitObjArrIndex]
        splitObj.data = null
        await postInitSplit(splitObj)
        return splitObj
      } else {
        const splitObj: ISplitObj = {
          id1,
          id2,
          data: null
        }

        await postInitSplit(splitObj)
        splitObjArr.push(splitObj)
        return splitObj
      }
    }
  }
}
export default {
  initSplit,
  destroySplit,
  ejectSplitObjArr
}
